<template>
  <RetailerSelectionComponent
    v-if="showComponent"
    :label="label"
    :hideLabel="hideLabel"
    :retailerLimit="retailerLimit"
    :allowedManufacturerIds="allowedTestDriveManufacturerIds"
    :blockedRangeIds="blockedRangeIds"
    :validationScope="validationScope" />
</template>

<script lang="ts">
import {
  Vue, Component, Prop, Inject
} from 'vue-property-decorator';
import { Validator } from 'vee-validate';

import RetailerSelectionComponent from '../enquiry/RetailerSelectionComponent.vue';

@Component({
  components: {
  RetailerSelectionComponent
  }
  })
export default class TestDriveRetailerSelectionComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: null })
  public validationScope!: string;

  @Prop({ default: 'Select your preferred dealership for your test drive' })
  public label!: string;

  @Prop({ default: 5 })
  public retailerLimit!: number;

  @Prop({ default: false })
  public hideLabel!: boolean;

  public get testDriveRequested(): boolean {
    return this.$store.getters['enquiryModule/testDriveRequested'];
  }

  public get blockedRangeIds(): number[] {
    return this.$store.getters['testDriveAvailabilityModule/blockedRangeIds'];
  }

  public get allowedTestDriveManufacturerIds(): number[] {
    return this.$store.getters['testDriveAvailabilityModule/allowedManufacturerIds'];
  }

  public get showComponent(): boolean {
    return this.testDriveRequested;
  }
}
</script>
